// extracted by mini-css-extract-plugin
export default {"auth-page":"AuthPage-module__auth-page___dYhiu","auth-page__logo":"AuthPage-module__auth-page__logo___zZ9aa"};